import { datadogRum } from '@datadog/browser-rum';
import React, { useContext, useEffect } from 'react';
import { messageLog } from 'utilities/helpers/logger/message-logger';
import { PageChangeContext } from 'utilities/hooks/page-change-context';
import { normalisedUrl } from 'utilities/router/api-fetch-path';
import { getWindow } from 'utilities/window';

/**
 * Updates on page navigation sends whenever new url is sent
 * Updates of Nielsen Tracking
 * Starts a new DataDog RUM view
 * */
export const PageNavigationHook = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  const { pageUrlChanged, getCurrentPath } = useContext(PageChangeContext);

  useEffect(() => {
    const isInit = pageUrlChanged === undefined;
    const currentPage = pageUrlChanged ?? getCurrentPath();
    /** Update Nielsen Page */
    getWindow()?.nielsenQueue.set({ init: isInit });
    /** Update Datadog Page */
    messageLog.trace(`[PATH] ${isInit ? '[INIT]' : '[NAV]'} View ${normalisedUrl(currentPage)}`);
    datadogRum.startView({
      name: normalisedUrl(currentPage),
    });
    /**
     * See ads-ready-provider for other datadog timers
     * e.g. datadogRum.addTiming(`Log_Ad_${name}_${suffix}`);
     */

    if (pageUrlChanged) {
      getWindow()?.AdUtils?.resetMapTakeover();
    }
  }, [pageUrlChanged, getCurrentPath]);

  return children;
};
